import { createContext, useContext, useMemo } from 'react';
import { useDerivedCohortInfo } from '../hooks/useDerivedCohortInfo';
import { useActiveFeatureFlags, useIsUngated } from '../v2/hooks/gating/useIsUngated';
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_VALUE = {
  loading: true,
  isUngatedForSeats: false,
  isHubSpotOnCredits: false,
  hasMismatchedProductsAndPopData: false,
  mismatchedProductsAndPopDataMetrics: undefined
};
export const DerivedCohortInfoContext = /*#__PURE__*/createContext(DEFAULT_VALUE);
export const DerivedCohortInfoProvider = ({
  children
}) => {
  const value = useDerivedCohortInfo();
  return /*#__PURE__*/_jsx(DerivedCohortInfoContext.Provider, {
    value: value,
    children: children
  });
};
export const useDerivedCohortInfoContext = () => useContext(DerivedCohortInfoContext);

// Public pricing pages only need a small subset of derived cohort info and
// can resolve it from feature flags alone. Avoids the POP + ProductDetails
// round trips the authenticated provider makes.
export const PublicDerivedCohortInfoProvider = ({
  children
}) => {
  const {
    loading: featureFlagsLoading
  } = useActiveFeatureFlags();
  const isHubSpotOnCredits = useIsUngated('hubspotoncredits');
  const isUngatedForSeats = useIsUngated('seats');
  const value = useMemo(() => ({
    loading: featureFlagsLoading,
    isUngatedForSeats,
    isHubSpotOnCredits,
    hasMismatchedProductsAndPopData: false,
    mismatchedProductsAndPopDataMetrics: undefined
  }), [featureFlagsLoading, isHubSpotOnCredits, isUngatedForSeats]);
  return /*#__PURE__*/_jsx(DerivedCohortInfoContext.Provider, {
    value: value,
    children: children
  });
};